import { $ } from '@/Engine/state';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { deleteSelectedModel } from '@/Engine/eventHandlers/libs/deleteSelectedModel';
import { isCursorOutsideToolChest } from '@/Engine/eventHandlers/libs/isModelOutsideToolChest';
import { useStoreUI } from '@/Store/storeUI';
import { Part } from '@/Engine/Part';
import { setPriorityForShields } from '@/Engine/eventHandlers/libs/setPriorityForSheilds';
import { setPositionForAccessory } from '@/Engine/eventHandlers/libs/setPositionForAccessory';

export const onPointerUpHandler = (event: MouseEvent): void => {
    useStoreUI().setDndItem(null);
    if (!$.selectedModel || !$.toolChest) return;
    $.app.controls.enableRotate = true;
    const obj =  $.selectedModel.userData.parent;
    const copyMoved = $.moved;
    $.up = true;
    $.moved = false;
    $.down = false;
    if (isCursorOutsideToolChest()) {
        deleteSelectedModel();
        return;
    }
    if (!copyMoved) {
        $.render();
        return;
    }
    if (obj.parentAccessory) {
        setPriorityForShields(obj);
        obj.childrenAccessory?.forEach((x: Part) => {
            setPositionForAccessory(x);
        });
    }

    if (obj?.isChangeChpuHard() && $.isChangeChpu) {
        obj.join($.isChangeChpu);
    }

    //удаление тех комплектующих, которые наложились
    //исключаем возможность поставить комплектующие внутрь другого объекта
    // if (obj.isRedMark()) {
    //     deleteSelectedModel();
    //     return;
    // }

    if ($.objWithoutWall) {
        deleteSelectedModel();
        return;
    }
    if (obj.key === 'accessory') {
        if (!obj.parentAccessory?.length) {
            deleteSelectedModel();
            return;
        }

        const holder = obj.getBoxHolderInChildren();
        if (obj.isPlasticBoxWithParentShield() && !holder) {
            $.toolChest.createHolder(obj);
        }
        if (obj.isPlasticBoxWithParentShelf()) {
            if (holder) $.toolChest.removeComponent(holder);
            setPositionForAccessory(obj);
        }

    }

    obj.isLeft = obj.scale.x < 0;
    useStoreCaseConfiguration().$patch({ caseItems: $.toolChest.raw.caseItems });
    $.render();
};
